<app-card-table
    translatePrefix="database.organizationAdministrationPage.contactPerson.table."
    [tableTitle]="'database.organizationAdministrationPage.contactPerson.table.title'"
    [columns]="columns"
    [showDetail]="isAllowed['organization.update']()"
    [showDelete]="isAllowed['organization.update']()"
    [gridData]="$any(store.data.getOrganizationCenterPersons())"
    [refreshCallback]="store.api.getOrganizationCenterPersons"
    [refreshCallbackFragment]="getPersonsFrag"
    [buttons]="buttons"
    (createCallback)="upsertContactPersonDialog()"
    (detailCallback)="upsertContactPersonDialog($event)"
    (deleteCallbackWithEvent)="unlinkPerson($event)"
    [additionalFilter]="additionalFilter()"
    [defaultSorters]="[{ column: 'validFrom', direction: 'DESC' }]"
>
    <ng-template pTemplate="name" let-data="data">
        {{ data | formatPerson }}
    </ng-template>

    <ng-template pTemplate="validFrom" let-data="data">
        {{ data | shortDate }}
    </ng-template>
</app-card-table>

<ng-template #buttons>
    <app-button
        icon="pi-user"
        [pTooltip]="'database.organizationAdministrationPage.contactPerson.primaryContactPersonButtonTitle' | translate"
        (clickEvent)="contactSelectDialog()"
    ></app-button>
</ng-template>
